import { Loader } from "@mantine/core";
import { ComponentProps } from "react";
import { FieldValues } from "react-hook-form";

import { useGetStates } from "@/hooks";

import { Input } from "../_Input";

type UfFieldsProps<TFieldValues extends FieldValues> = Omit<ComponentProps<typeof Input.Select<TFieldValues>>, "data" | "leftSection">;

export function UfFields<TFieldValues extends FieldValues>({ control, name, ...props }: UfFieldsProps<TFieldValues>) {
  const { data, isLoading } = useGetStates();

  return <Input.Select data={data.options} leftSection={isLoading && <Loader size="sm" />} control={control} name={name} {...props} />;
}
